export default __webpack_public_path__ + "static/step6-1453592503fe290e78c57338b44c061c.svg";